import { render, staticRenderFns } from "./xwzx.vue?vue&type=template&id=60794372&scoped=true"
import script from "./xwzx.vue?vue&type=script&lang=js"
export * from "./xwzx.vue?vue&type=script&lang=js"
import style0 from "./xwzx.vue?vue&type=style&index=0&id=60794372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60794372",
  null
  
)

export default component.exports